import { createFileRoute } from '@tanstack/react-router'
import { ObservabilityList } from '../../components/observability/ObservabilityList'

export const Route = createFileRoute('/dev/observability')({
  component: ObservabilityList,
})
